export default __webpack_public_path__ + "static/media/high-icon-2.ab4ff6d8.png";